import * as api from '../../requests'

export const toggleFormManagerLoading = loading => ({
  type: '@@fm/TOGGLE_LOADING',
  loading
})

export const setAllWizards = (wizards, category) => ({
  type: '@@fm/SET_ALL_WIZARDS',
  wizards,
  category
})

export const populateStructure = payload => ({
  type: '@@fm/POPULATE_STRUCTURE',
  payload
})

export const setFilter = filter => ({
  type: '@@fm/SET_FILTER',
  filter
})

export const setActiveCategory = category => ({
  type: '@@fm/SET_ACTIVE_CATEGORY',
  category
})

export const fetchStructure = () => dispatch => {
  api.GET_APP_SETTING_BY_NAME('FORM_MANAGER_STRUCTURE', structure => {
    dispatch(
      populateStructure({
        ...JSON.parse(structure.VALUE),
        appSettingId: structure.APP_SETTING_ID
      })
    )
  })
}

export const getAllWizards = category => dispatch => {
  new Promise(resolve => {
    api.GET_ALL_WIZARDS(category, data => {
      let wizards = data.reduce((obj, wizard) => {
        obj[wizard.FORM_DEFINITION_ID] = wizard
        return obj
      }, {})
      dispatch(setAllWizards(wizards, category))
    })
  })
}

export const saveFormManagerStructure = callback => (dispatch, getState) => {
  let formManager = getState().formManager
  api.UPDATE_APP_SETTING_BY_ID(
    formManager.appSettingId,
    {
      NAME: 'FORM_MANAGER_STRUCTURE',
      VALUE: JSON.stringify({
        categoriesOrder: formManager.categoriesOrder,
        categories: formManager.categories,
        categoryIcons: formManager.categoryIcons
      }),
      CATEGORY: 'ADMIN',
      DESCR: ''
    },
    data => {
      callback(true)
    }
  )
}

export const toggleDragging = dragging => ({
  type: '@@fm/TOGGLE_DRAGGING',
  dragging
})

export const toggleSaving = saving => ({
  type: '@@fm/TOGGLE_SAVING',
  saving
})

export const moveWizard = ({ origin, target }) => dispatch => {
  dispatch({
    type: '@@fm/MOVE_WIZARD',
    origin,
    target
  })
  dispatch(toggleSaving(true))
  dispatch(
    saveFormManagerStructure(response => {
      if (response === true) {
        dispatch(toggleSaving(false))
      }
    })
  )
}

export const setIsOver = isOver => ({
  type: '@@fm/SET_ISOVER',
  isOver
})

export const setWasOver = wasOver => ({
  type: '@@fm/SET_WASOVER',
  wasOver
})

export const moveWizardToEmptyCategory = ({ origin, target }) => dispatch => {
  dispatch({
    type: '@@fm/MOVE_WIZARD_TO_EMPTY_CATEGORY',
    origin,
    target
  })
  dispatch(toggleSaving(true))
  dispatch(
    saveFormManagerStructure(response => {
      if (response === true) {
        dispatch(toggleSaving(false))
      }
    })
  )
}

export const moveWizardToLast = ({ origin, target }) => dispatch => {
  dispatch({
    type: '@@fm/MOVE_WIZARD_TO_LAST',
    origin,
    target
  })
  dispatch(toggleSaving(true))
  dispatch(
    saveFormManagerStructure(response => {
      if (response === true) {
        dispatch(toggleSaving(false))
      }
    })
  )
}

export const reorderCategory = ({ direction, categoryId, categoryIndex }) => dispatch => {
  dispatch({
    type: '@@fm/REORDER_CATEGORY',
    direction,
    categoryId,
    categoryIndex
  })
  dispatch(toggleSaving(true))
  dispatch(
    saveFormManagerStructure(response => {
      if (response === true) {
        dispatch(toggleSaving(false))
      }
    })
  )
}

export const setCategoryTitle = ({ title, categoryId }) => dispatch => {
  dispatch({
    type: '@@fm/SET_CATEGORY_TITLE',
    categoryId,
    title
  })
  dispatch(toggleSaving(true))
  dispatch(
    saveFormManagerStructure(response => {
      if (response === true) {
        dispatch(toggleSaving(false))
      }
    })
  )
}

export const setCategoryAbbreviation = ({ abbreviation, categoryId }) => dispatch => {
  dispatch({
    type: '@@fm/SET_CATEGORY_ABBREVIATION',
    categoryId,
    abbreviation
  })
  dispatch(toggleSaving(true))
  dispatch(
    saveFormManagerStructure(response => {
      if (response === true) {
        dispatch(toggleSaving(false))
      }
    })
  )
}

export const addCategory = () => dispatch => {
  dispatch({
    type: '@@fm/ADD_CATEGORY'
  })
  dispatch(toggleSaving(true))
  dispatch(
    saveFormManagerStructure(response => {
      if (response === true) {
        dispatch(toggleSaving(false))
      }
    })
  )
}

export const deleteCategory = ({ categoryId, categoryIndex }) => dispatch => {
  dispatch({
    type: '@@fm/DELETE_CATEGORY',
    categoryId,
    categoryIndex
  })
  dispatch(toggleSaving(true))
  dispatch(
    saveFormManagerStructure(response => {
      if (response === true) {
        dispatch(toggleSaving(false))
      }
    })
  )
}

export const publishWizard = ({ origin, target }) => dispatch => {
  dispatch({
    type: '@@fm/PUBLISH_WIZARD',
    origin,
    target
  })
  dispatch(toggleSaving(true))
  dispatch(
    saveFormManagerStructure(response => {
      if (response === true) {
        dispatch(toggleSaving(false))
      }
    })
  )
}

export const publishWizardToLast = ({ origin, target }) => dispatch => {
  dispatch({
    type: '@@fm/PUBLISH_WIZARD_TO_LAST',
    origin,
    target
  })
  dispatch(toggleSaving(true))
  dispatch(
    saveFormManagerStructure(response => {
      if (response === true) {
        dispatch(toggleSaving(false))
      }
    })
  )
}

export const publishWizardToEmptyCategory = ({ origin, target }) => dispatch => {
  dispatch({
    type: '@@fm/PUBLISH_WIZARD_TO_EMPTY_CATEGORY',
    origin,
    target
  })
  dispatch(toggleSaving(true))
  dispatch(
    saveFormManagerStructure(response => {
      if (response === true) {
        dispatch(toggleSaving(false))
      }
    })
  )
}

export const unpublishWizard = ({ origin }) => (dispatch) => {
  if (origin.categoryId !== 'uncategorized') {
    dispatch({
      type: '@@fm/UNPUBLISH_WIZARD',
      origin,
    })
    dispatch(toggleSaving(true))
    dispatch(
      saveFormManagerStructure((response) => {
        if (response === true) {
          dispatch(toggleSaving(false))
        }
      })
    )
  }
}

export const cloneWizard = (formDefinitionId, title) => (dispatch, getState) => {
  let formManager = getState().formManager
  let wizard = formManager.wizards[formManager.activeCategory][formDefinitionId]
  api.CLONE_WIZARD(
    formDefinitionId,
    {
      TITLE: title === '' ? `Copy of ${wizard.TITLE}` : title,
      DESCR: wizard.DESCR,
      CATEGORY: wizard.CATEGORY
    },
    response => {
      dispatch(getAllWizards(formManager.activeCategory))
    }
  )
}

export const archiveWizard = formDefinitionId => (dispatch, getState) => {
  api.ARCHIVE_WIZARD(formDefinitionId, {}, response => {
    dispatch(getAllWizards(getState().formManager.activeCategory))
  })
}

export const toggleImportDialog = isOpen => ({
  type: '@@fm/TOGGLE_IMPORT_DIALOG',
  isOpen
})

export const importToLast = ({ categoryId, formDefinitionId }, callback) => dispatch => {
  dispatch({
    type: '@@fm/IMPORT_TO_LAST',
    categoryId,
    formDefinitionId
  })
  dispatch(toggleSaving(true))
  dispatch(
    saveFormManagerStructure(response => {
      if (response === true) {
        if (callback) {
          callback()
        }
        dispatch(toggleSaving(false))
      }
    })
  )
}

export const toggleVisibility = ({ on, categoryId }, callback) => dispatch => {
  dispatch({
    type: '@@fm/TOGGLE_VISIBILITY',
    on,
    categoryId
  })
  dispatch(toggleSaving(true))
  dispatch(
    saveFormManagerStructure(response => {
      if (response === true) {
        if (callback) {
          callback()
        }
        dispatch(toggleSaving(false))
      }
    })
  )
}

export const setAndPushIcon = icon => dispatch => {
  dispatch(setIcon(icon))
  dispatch(toggleSaving(true))
  dispatch(
    saveFormManagerStructure(response => {
      if (response === true) {
        dispatch(toggleSaving(false))
      }
    })
  )
}

export const setIcon = icon => ({
  type: '@@fm/SET_ICON',
  icon
})



// WEBPACK FOOTER //
// ./src/components/FormManager/FormManagerActions.js